import { coerceOptionalString } from '@evimo/components/maintenance/work-orders/WorkOrderKanbanPageContainer/utils';

const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function normalizeIncidentId(value: unknown): string | null {
  const coerced = coerceOptionalString(value);
  if (!coerced) {
    return null;
  }
  return UUID_RE.test(coerced) ? coerced : null;
}

export type CurativeIncidentFieldsInput = {
  incidentId?: unknown;
  incidentCode?: unknown;
  incidentTitle?: unknown;
};

export function pickCurativeIncidentFields(
  source: CurativeIncidentFieldsInput,
): {
  incidentId: string | null;
  incidentCode: string | null;
  incidentTitle: string | null;
} {
  return {
    incidentId: normalizeIncidentId(source.incidentId),
    incidentCode: coerceOptionalString(source.incidentCode),
    incidentTitle: coerceOptionalString(source.incidentTitle),
  };
}
